import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  connect() {
    const card = document.getElementById(this.targetValue)
    if (card) {
      const timerController = this.application.getControllerForElementAndIdentifier(card, "rest-timer")
      if (timerController) {
        timerController.start()
      }
    }

    this.element.remove()
  }
}
